import { BUTTON_TYPE, COLORS } from "@helpers/constants"
import { getSubjectBackgroundClass } from "@helpers/subject"
import classNames from "classnames"


const baseButtonStyle = 'font-secondary text-sm rounded-full whitespace-nowrap transition-colors inline-flex items-center'
const buttonTypeColors = {
    primary: {
        background: COLORS.PRIMARY_GREEN.BACKGROUND,
        text: COLORS.WHITE.TEXT,
        hover: {
            background: COLORS.PRIMARY_GREEN.HOVER,
            text: 'hover:' + COLORS.WHITE.TEXT,
        },
        active: {
            background: COLORS.PRIMARY_GREEN.ACTIVE,
            text: COLORS.WHITE.TEXT,
        }
    },
    secondary: {
        background: COLORS.SECONDARY_GREEN.BACKGROUND,
        text: COLORS.BLACK.TEXT,
        hover: {
            background: COLORS.SECONDARY_GREEN.HOVER,
            text: 'hover:' + COLORS.BLACK.TEXT,
        },
        active: {
            background: COLORS.SECONDARY_GREEN.ACTIVE,
            text: COLORS.BLACK.TEXT,
        }
    },
    darkGrey: {
        background: COLORS.DARK_GREY.BACKGROUND,
        text: COLORS.WHITE.TEXT,
        hover: {
            background: 'hover:' + COLORS.LIGHT_DARK_GREY.BACKGROUND,
            text: 'hover:' + COLORS.WHITE.TEXT,
        },
        active: {
            background: COLORS.DARK_GREY.BACKGROUND,
            text: COLORS.WHITE.TEXT,
        },
        disabled: {
            background: 'disabled:' + COLORS.DARK_GREY.BACKGROUND,
            text: 'disabled:' + COLORS.LIGHT_DARK_GREY.TEXT,
        }
    },
    darkDarkGrey: {
        background: COLORS.DARK_DARK_GREY.BACKGROUND,
        text: COLORS.WHITE.TEXT,
        hover: {
            background: 'hover:' + COLORS.MEDIUM_DARK_GREY.BACKGROUND,
            text: 'hover:' + COLORS.WHITE.TEXT,
        },
        active: {
            background: COLORS.DARK_DARK_GREY.BACKGROUND,
            text: COLORS.WHITE.TEXT,
        },
        disabled: {
            background: 'disabled:' + COLORS.MEDIUM_DARK_GREY.BACKGROUND,
            text: 'disabled:' + COLORS.MEDIUM_DARK_GREY.TEXT,
        }
    },
    candyRed: {
        background: COLORS.CANDY_RED.BACKGROUND,
        text: COLORS.WHITE.TEXT,
        hover: {
            background: 'hover:' + COLORS.ALERT_RED_DARK.BACKGROUND,
            text: 'hover:' + COLORS.WHITE.TEXT,
        },
        active: {
            background: COLORS.ALERT_RED_DARK.BACKGROUND,
            text: COLORS.WHITE.TEXT,
        },
        disabled: {
            background: 'disabled:' + COLORS.MEDIUM_DARK_GREY.BACKGROUND,
            text: 'disabled:' + COLORS.MEDIUM_DARK_GREY.TEXT,
        }
    },
    primaryOutline: {
        border: COLORS.PRIMARY_GREEN.BORDER,
        text: COLORS.PRIMARY_GREEN.TEXT,
        hover: {
            background: 'hover:bg-primaryGreen',
            text: 'hover:' + COLORS.WHITE.TEXT,
        },
        active: {
            background: COLORS.PRIMARY_GREEN.BACKGROUND,
            text: COLORS.WHITE.TEXT,
        }
    },
    secondaryOutline: {
        border: COLORS.SECONDARY_GREEN.BORDER,
        text: COLORS.SECONDARY_GREEN.TEXT,
        hover: {
            background: 'hover:' + COLORS.SECONDARY_GREEN.BACKGROUND,
            text: 'hover:' + COLORS.BLACK.TEXT,
        },
        active: {
            background: COLORS.SECONDARY_GREEN.BACKGROUND,
            text: COLORS.BLACK.TEXT,
        }
    },
    whiteOutline: {
        border: COLORS.WHITE.BORDER,
        text: COLORS.WHITE.TEXT,
        hover: {
            background: 'hover:' + COLORS.WHITE.BACKGROUND,
            text: 'hover:' + COLORS.BLACK.TEXT,
        },
        active: {
            background: COLORS.WHITE.BACKGROUND,
            text: COLORS.BLACK.TEXT,
        }
    },
    mediumDarkGrey: {
        background: COLORS.MEDIUM_DARK_GREY.BACKGROUND,
        text: COLORS.WHITE.TEXT,
        hover: {
            background: 'hover:' + COLORS.LIGHT_DARK_GREY.BACKGROUND,
            text: 'hover:' + COLORS.WHITE.TEXT,
        },
        active: {
            background: COLORS.LIGHT_DARK_GREY.BACKGROUND,
            text: COLORS.WHITE.TEXT,
        }
    },
    alertRedDark: {
        background: COLORS.ALERT_RED_DARK.BACKGROUND,
        text: COLORS.WHITE.TEXT,
        hover: {
            background: 'hover:bg-[#772020]',
            text: 'hover:' + COLORS.WHITE.TEXT,
        },
        active: {
            background: COLORS.ALERT_RED_DARK.BACKGROUND,
            text: COLORS.WHITE.TEXT,
        }
    },
}

export const ButtonType = (type, active, subject) => {
    let colors
    if (!type) return baseButtonStyle
    if (type === BUTTON_TYPE.SUBJECT) {
        const blackHoverText = ['geografi', 'biologi'].includes(subject)
        colors = {
            background: getSubjectBackgroundClass(subject, 'light'),
            text: COLORS.BLACK.TEXT,
            hover: {
                background: 'hover:' + getSubjectBackgroundClass(subject, 'dark'),
                text: 'hover:' + (blackHoverText ? COLORS.BLACK.TEXT : COLORS.WHITE.TEXT),
            },
        }
    } else {
        colors = buttonTypeColors[type]
    }

    return classNames(
        baseButtonStyle,
        colors.active && active ? {
            [colors.text]: !active,
            [colors.background]: !active,
            [colors.active.background]: active,
            [colors.active.text]: active,
        } : [
            colors.text,
            colors.background
        ],
        colors.hover ? [
            colors.hover.background,
            colors.hover?.text
        ] : null,
        colors.border ? {
            border: true,
            [colors.border]: true,
        } : null,
        colors.disabled ? [
            colors.disabled.background,
            colors.disabled.text,
        ] : 'disabled:bg-mediumGrey disabled:text-black'
    )
}

export const Disabled = 'bg-mediumGrey text-black pointer-events-none'

export const ButtonSize = {
    noPadding: 'p-0',
    noSize: 'py-2.5 px-0',
    small: 'py-1 px-3',
    medium: 'min-h-[34px] px-3.5',
    large: 'min-h-[44px] px-4',
    iconOnly: 'py-2.5 p-2.5',
    iconCircle: 'h-[34px] w-[34px] flex align-center justify-center'
}

export const IconRight = `flex flex-row-reverse`

export const SetPadding = {
    right: 'pr-2',
    left: 'pl-2',
    top: 'pt-2',
    bottom: 'pb-2',
    noPadding: 'p-0',
}

export const Margin = `mx-2`
export const MarginBottom = `mb-2`
export const MarginRight = `mr-2`
export const MarginLeft = `ml-2`
